
import type { ClickOrPressEvent } from 'types/mouseEvents';
import Image from '../Image/Image';

// *****To update this file see `tools/generate-icon-imports.mjs`*****

import { ReactComponent as Add } from 'assets/icons/add.svg?react';
import { ReactComponent as ArrowAngled } from 'assets/icons/arrow-angled.svg?react';
import { ReactComponent as ArrowDown } from 'assets/icons/arrow-down.svg?react';
import { ReactComponent as ArrowDropDown } from 'assets/icons/arrow-drop-down.svg?react';
import { ReactComponent as ArrowDropUp } from 'assets/icons/arrow-drop-up.svg?react';
import { ReactComponent as ArrowLeftAlt } from 'assets/icons/arrow-left-alt.svg?react';
import { ReactComponent as ArrowLeft } from 'assets/icons/arrow-left.svg?react';
import { ReactComponent as ArrowRightAlt } from 'assets/icons/arrow-right-alt.svg?react';
import { ReactComponent as ArrowRight } from 'assets/icons/arrow-right.svg?react';
import { ReactComponent as ArrowUp } from 'assets/icons/arrow-up.svg?react';
import { ReactComponent as Calendar } from 'assets/icons/calendar.svg?react';
import { ReactComponent as Call } from 'assets/icons/call.svg?react';
import { ReactComponent as CheckCircleOutline } from 'assets/icons/check-circle-outline.svg?react';
import { ReactComponent as CheckCircle } from 'assets/icons/check-circle.svg?react';
import { ReactComponent as Check } from 'assets/icons/check.svg?react';
import { ReactComponent as ChevronDown } from 'assets/icons/chevron-down.svg?react';
import { ReactComponent as ChevronLeft } from 'assets/icons/chevron-left.svg?react';
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg?react';
import { ReactComponent as ChevronUp } from 'assets/icons/chevron-up.svg?react';
import { ReactComponent as Close } from 'assets/icons/close.svg?react';
import { ReactComponent as CreditCard } from 'assets/icons/credit_card.svg?react';
import { ReactComponent as CrossCircle } from 'assets/icons/cross-circle.svg?react';
import { ReactComponent as Description } from 'assets/icons/description.svg?react';
import { ReactComponent as Dollar } from 'assets/icons/dollar.svg?react';
import { ReactComponent as Download } from 'assets/icons/download.svg?react';
import { ReactComponent as Emergency } from 'assets/icons/emergency.svg?react';
import { ReactComponent as ErrorOutline } from 'assets/icons/error-outline.svg?react';
import { ReactComponent as Error } from 'assets/icons/error.svg?react';
import { ReactComponent as EventRepeat } from 'assets/icons/event-repeat.svg?react';
import { ReactComponent as Facebook } from 'assets/icons/facebook.svg?react';
import { ReactComponent as Fax } from 'assets/icons/fax.svg?react';
import { ReactComponent as FileCopy } from 'assets/icons/file-copy.svg?react';
import { ReactComponent as Fire } from 'assets/icons/fire.svg?react';
import { ReactComponent as Google } from 'assets/icons/google.svg?react';
import { ReactComponent as Help } from 'assets/icons/help.svg?react';
import { ReactComponent as Home } from 'assets/icons/home.svg?react';
import { ReactComponent as ImageFill } from 'assets/icons/image-fill.svg?react';
import { ReactComponent as Instagram } from 'assets/icons/instagram.svg?react';
import { ReactComponent as KeyboardArrowDown } from 'assets/icons/keyboard-arrow-down.svg?react';
import { ReactComponent as Language } from 'assets/icons/language.svg?react';
import { ReactComponent as LgChevronLeft } from 'assets/icons/lg-chevron-left.svg?react';
import { ReactComponent as LgChevronRight } from 'assets/icons/lg-chevron-right.svg?react';
import { ReactComponent as Link } from 'assets/icons/link.svg?react';
import { ReactComponent as Linkedin } from 'assets/icons/linkedin.svg?react';
import { ReactComponent as LocationOn } from 'assets/icons/location_on.svg?react';
import { ReactComponent as LockFilled } from 'assets/icons/lock-filled.svg?react';
import { ReactComponent as Mail } from 'assets/icons/mail.svg?react';
import { ReactComponent as Menu } from 'assets/icons/menu.svg?react';
import { ReactComponent as Messenger } from 'assets/icons/messenger.svg?react';
import { ReactComponent as MoreHoriz } from 'assets/icons/more-horiz.svg?react';
import { ReactComponent as MoreVert } from 'assets/icons/more-vert.svg?react';
import { ReactComponent as News } from 'assets/icons/news.svg?react';
import { ReactComponent as Offer } from 'assets/icons/offer.svg?react';
import { ReactComponent as Office } from 'assets/icons/office.svg?react';
import { ReactComponent as OpenInNew } from 'assets/icons/open_in_new.svg?react';
import { ReactComponent as PersonOutline } from 'assets/icons/person-outline.svg?react';
import { ReactComponent as Person } from 'assets/icons/person.svg?react';
import { ReactComponent as Pinterest } from 'assets/icons/pinterest.svg?react';
import { ReactComponent as Pause } from 'assets/icons/pause.svg?react';
import { ReactComponent as PlayArrow } from 'assets/icons/play-arrow.svg?react';
import { ReactComponent as Protection } from 'assets/icons/protection.svg?react';
import { ReactComponent as Remove } from 'assets/icons/remove.svg?react';
import { ReactComponent as RestartAlt } from 'assets/icons/restart_alt.svg?react';
import { ReactComponent as Search } from 'assets/icons/search.svg?react';
import { ReactComponent as Secure } from 'assets/icons/secure.svg?react';
import { ReactComponent as Share } from 'assets/icons/share.svg?react';
import { ReactComponent as Star } from 'assets/icons/star.svg?react';
import { ReactComponent as TextSnippet } from 'assets/icons/text-snippet.svg?react';
import { ReactComponent as Time } from 'assets/icons/time.svg?react';
import { ReactComponent as Visibility } from 'assets/icons/visibility.svg?react';
import { ReactComponent as Warning } from 'assets/icons/warning.svg?react';
import { ReactComponent as Whatsapp } from 'assets/icons/whatsapp.svg?react';
import { ReactComponent as X } from 'assets/icons/x.svg?react';
import { ReactComponent as Youtube } from 'assets/icons/youtube.svg?react';

export type IconString =

| 'add'
| 'arrow-angled'
| 'arrow-down'
| 'arrow-drop-down'
| 'arrow-drop-up'
| 'arrow-left-alt'
| 'arrow-left'
| 'arrow-right-alt'
| 'arrow-right'
| 'arrow-up'
| 'calendar'
| 'call'
| 'check-circle-outline'
| 'check-circle'
| 'check'
| 'chevron-down'
| 'chevron-left'
| 'chevron-right'
| 'chevron-up'
| 'close'
| 'credit_card'
| 'cross-circle'
| 'description'
| 'dollar'
| 'download'
| 'emergency'
| 'error-outline'
| 'error'
| 'event-repeat'
| 'facebook'
| 'fax'
| 'file-copy'
| 'fire'
| 'google'
| 'help'
| 'home'
| 'image-fill'
| 'instagram'
| 'keyboard-arrow-down'
| 'language'
| 'lg-chevron-left'
| 'lg-chevron-right'
| 'link'
| 'linkedin'
| 'location_on'
| 'lock-filled'
| 'mail'
| 'menu'
| 'messenger'
| 'more-horiz'
| 'more-vert'
| 'news'
| 'offer'
| 'office'
| 'open_in_new'
| 'person-outline'
| 'person'
| 'pinterest'
| 'play-arrow'
| 'pause'
| 'protection'
| 'remove'
| 'restart_alt'
| 'search'
| 'secure'
| 'share'
| 'star'
| 'text-snippet'
| 'time'
| 'visibility'
| 'warning'
| 'whatsapp'
| 'x'
| 'youtube';

export type IconSVG = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
export const allIconComponents: Record<IconString, IconSVG> = {
    add: Add,
    'arrow-angled': ArrowAngled,
    'arrow-down': ArrowDown,
    'arrow-drop-down': ArrowDropDown,
    'arrow-drop-up': ArrowDropUp,
    'arrow-left-alt': ArrowLeftAlt,
    'arrow-left': ArrowLeft,
    'arrow-right-alt': ArrowRightAlt,
    'arrow-right': ArrowRight,
    'arrow-up': ArrowUp,
    calendar: Calendar,
    call: Call,
    'check-circle-outline': CheckCircleOutline,
    'check-circle': CheckCircle,
    check: Check,
    'chevron-down': ChevronDown,
    'chevron-left': ChevronLeft,
    'chevron-right': ChevronRight,
    'chevron-up': ChevronUp,
    close: Close,
    credit_card: CreditCard,
    'cross-circle': CrossCircle,
    description: Description,
    dollar: Dollar,
    download: Download,
    emergency: Emergency,
    'error-outline': ErrorOutline,
    error: Error,
    'event-repeat': EventRepeat,
    facebook: Facebook,
    fax: Fax,
    'file-copy': FileCopy,
    fire: Fire,
    google: Google,
    help: Help,
    home: Home,
    'image-fill': ImageFill,
    instagram: Instagram,
    'keyboard-arrow-down': KeyboardArrowDown,
    language: Language,
    'lg-chevron-left': LgChevronLeft,
    'lg-chevron-right': LgChevronRight,
    link: Link,
    linkedin: Linkedin,
    location_on: LocationOn,
    'lock-filled': LockFilled,
    mail: Mail,
    menu: Menu,
    messenger: Messenger,
    'more-horiz': MoreHoriz,
    'more-vert': MoreVert,
    news: News,
    offer: Offer,
    office: Office,
    open_in_new: OpenInNew,
    'person-outline': PersonOutline,
    person: Person,
    pinterest: Pinterest,
    'play-arrow': PlayArrow,
    pause: Pause,
    protection: Protection,
    remove: Remove,
    restart_alt: RestartAlt,
    search: Search,
    secure: Secure,
    share: Share,
    star: Star,
    'text-snippet': TextSnippet,
    time: Time,
    visibility: Visibility,
    warning: Warning,
    whatsapp: Whatsapp,
    x: X,
    youtube: Youtube,
};

interface IconProps {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    icon?: IconString | string;
    className?: string;
    style?: React.CSSProperties;
    // eslint-disable-next-line no-unused-vars
    onClick?: (event: ClickOrPressEvent) => void;
    // Padded icon props
    paddedIcon?: boolean;
    paddedIconStyle?: 'default' | 'inverted';
    paddedIconSize?: 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl';
    iconTheme?: 'navy' | 'aqua' | 'green' | 'magenta' | 'orange' | 'yellow';
    // Custom icon props
    customIcon?: string;
}

// Converts spaces and dots to dashes, preserves underscores
const kebabCase = (str: string): string => {
    return str.toLowerCase().replace(/[\s.]+/g, '-');
};

const Icon: React.FC<IconProps> = props => {
    const { icon, className, style, onClick, paddedIcon, paddedIconStyle, paddedIconSize, iconTheme, customIcon } = props;

    // Early return if neither icon nor customIcon is provided
    if (!icon && !customIcon) {
        return null;
    }

    const isClickableClass = onClick ? 'svg-icon-clickable' : '';

    if (paddedIcon) {
        // Padded icon with container div
        const paddedStyle = paddedIconStyle || 'default';
        const paddedSize = paddedIconSize || 'md';
        const theme = iconTheme || '';

        const containerClass = `icon-padded icon-padded-${paddedStyle} icon-padded-${paddedSize} ${theme}`;

        if (customIcon) {
            // Custom icon using Image component
            return (
                <div className={containerClass} onClick={onClick} style={style}>
                    <Image
                        imgSrc={customIcon}
                        imgCustomClass="custom-icon"
                        imgWidth={48}
                        imgHeight={48}
                        disableLazyLoading={false}
                    />
                </div>
            );
        }

        if (icon) {
            // Regular icon
            const iconName = kebabCase(icon) as IconString;
            const SpecificIcon = allIconComponents[iconName];

            if (!SpecificIcon) {
                return null;
            }

            const iconClass = `svg-icon ${className ? className : ''}`;

            return (
                <div className={containerClass} onClick={onClick} style={style}>
                    <SpecificIcon className={iconClass} role="img" />
                </div>
            );
        }
    }

    // Non-padded icons
    if (customIcon) {
        // Custom icon using Image component
        const themeClass = iconTheme || '';
        const customIconClass = `custom-icon ${isClickableClass} ${themeClass} ${className ? className : ''}`;
        return (
            <Image
                imgSrc={customIcon}
                imgCustomClass={customIconClass}
                imgWidth={48}
                imgHeight={48}
                disableLazyLoading={false}
                onClick={onClick}
                style={style}
            />
        );
    }

    if (icon) {
        // Regular non-padded icon
        const iconName = kebabCase(icon) as IconString;
        const SpecificIcon = allIconComponents[iconName];

        if (!SpecificIcon) {
            return null;
        }

        const themeClass = iconTheme || '';
        const iconClass = `svg-icon ${isClickableClass} ${themeClass} ${className ? className : ''}`;

        return style ?
            <SpecificIcon onClick={onClick} className={iconClass} style={style} role="img" /> :
            <SpecificIcon onClick={onClick} className={iconClass} role="img" />;
    }

    return null;
};

export default Icon;
